import { render, staticRenderFns } from "./userTable.vue?vue&type=template&id=088233c9&scoped=true"
import script from "./userTable.vue?vue&type=script&lang=ts"
export * from "./userTable.vue?vue&type=script&lang=ts"
import style0 from "./userTable.vue?vue&type=style&index=0&id=088233c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088233c9",
  null
  
)

export default component.exports